var map = {
	"./ion-action-sheet.entry.js": [
		140,
		5
	],
	"./ion-alert.entry.js": [
		141,
		6
	],
	"./ion-app_8.entry.js": [
		142,
		7
	],
	"./ion-avatar_3.entry.js": [
		143,
		17
	],
	"./ion-back-button.entry.js": [
		144,
		18
	],
	"./ion-backdrop.entry.js": [
		145,
		43
	],
	"./ion-button_2.entry.js": [
		146,
		19
	],
	"./ion-card_5.entry.js": [
		147,
		20
	],
	"./ion-checkbox.entry.js": [
		148,
		21
	],
	"./ion-chip.entry.js": [
		149,
		22
	],
	"./ion-col_3.entry.js": [
		150,
		44
	],
	"./ion-datetime_3.entry.js": [
		151,
		10
	],
	"./ion-fab_3.entry.js": [
		152,
		23
	],
	"./ion-img.entry.js": [
		153,
		45
	],
	"./ion-infinite-scroll_2.entry.js": [
		154,
		46
	],
	"./ion-input.entry.js": [
		155,
		24
	],
	"./ion-item-option_3.entry.js": [
		156,
		25
	],
	"./ion-item_8.entry.js": [
		157,
		26
	],
	"./ion-loading.entry.js": [
		158,
		27
	],
	"./ion-menu_3.entry.js": [
		159,
		28
	],
	"./ion-modal.entry.js": [
		160,
		8
	],
	"./ion-nav_2.entry.js": [
		161,
		14
	],
	"./ion-popover.entry.js": [
		162,
		9
	],
	"./ion-progress-bar.entry.js": [
		163,
		29
	],
	"./ion-radio_2.entry.js": [
		164,
		30
	],
	"./ion-range.entry.js": [
		165,
		31
	],
	"./ion-refresher_2.entry.js": [
		166,
		11
	],
	"./ion-reorder_2.entry.js": [
		167,
		16
	],
	"./ion-ripple-effect.entry.js": [
		168,
		47
	],
	"./ion-route_4.entry.js": [
		169,
		32
	],
	"./ion-searchbar.entry.js": [
		170,
		33
	],
	"./ion-segment_2.entry.js": [
		171,
		34
	],
	"./ion-select_3.entry.js": [
		172,
		35
	],
	"./ion-slide_2.entry.js": [
		173,
		48
	],
	"./ion-spinner.entry.js": [
		174,
		13
	],
	"./ion-split-pane.entry.js": [
		175,
		49
	],
	"./ion-tab-bar_2.entry.js": [
		176,
		36
	],
	"./ion-tab_2.entry.js": [
		177,
		15
	],
	"./ion-text.entry.js": [
		178,
		37
	],
	"./ion-textarea.entry.js": [
		179,
		38
	],
	"./ion-toast.entry.js": [
		180,
		39
	],
	"./ion-toggle.entry.js": [
		181,
		12
	],
	"./ion-virtual-scroll.entry.js": [
		182,
		50
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 73;
module.exports = webpackAsyncContext;